import { render, staticRenderFns } from "./MtExpenditure.vue?vue&type=template&id=b2f97cdc&scoped=true&"
import script from "./MtExpenditure.vue?vue&type=script&lang=js&"
export * from "./MtExpenditure.vue?vue&type=script&lang=js&"
import style0 from "./MtExpenditure.vue?vue&type=style&index=0&id=b2f97cdc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f97cdc",
  null
  
)

export default component.exports